import React from 'react';
import { StarsSelector } from '@prosolve/common-components-ui'

export default ({
  questionId,
  answers,
  setAnswers,
  starLabels,
  totalStars,
  hasInvalidMark
}) => {

  const answerObj =  answers[questionId] || {};
  const {
    answerText = ''
  } = answerObj;

  const onUpdateAnswer = (val) => {
    const updateObj = { answerText: val }
    setAnswers({
      ...answers,
      [questionId]: updateObj
    })
  }

  const onStarsChanged = (stars) => {
    if (stars > 0) {
      onUpdateAnswer(stars)
    }
  }

  const initStarValue = (answerText && Number(answerText)) || 0;

  return (
    <div style={{ position: 'relative' }}>
      <StarsSelector
        initStarValue={initStarValue}
        starLabels={starLabels}
        totalStars={totalStars}
        selectedStarColor='#d2275a'
        onStarsChanged={onStarsChanged}
      />
      {
        hasInvalidMark &&
        <div style={{ position: 'absolute', bottom: '-20px', fontStyle: 'italic', fontSize: '15px', color: hasInvalidMark ? '#ef0c0c' : 'inherit' }}>
          {'*Required'}
        </div>
      }
    </div>
  )
}